import fp from 'lodash/fp';
import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { color } from '@deerplusofficial/pos-helper';

const activeStyle = css`
  color: ${color.text.accent};
  font-weight: bold;
  pointer-events: none;
`;

const Container = styled.a.attrs({ role: 'button', tabIndex: 0 })`
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  outline: 0;
  color: ${color.text.secondary};
  cursor: pointer;
  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
    `};
  ${props => props.active && activeStyle};
  &:hover {
    color: ${color.text.accent};
  }
`;

class Cell extends PureComponent {
  static propTypes = {
    page: PropTypes.number,
    onPageChange: PropTypes.func
  };

  static defaultProps = {
    page: 1,
    onPageChange: fp.identity
  };

  onPageChange = () => {
    const { page, onPageChange } = this.props;
    onPageChange(page);
  };

  render() {
    const { children, ...props } = this.props;

    return (
      <Container
        onPress={this.onPageChange}
        onClick={this.onPageChange}
        {...props}
      >
        {children}
      </Container>
    );
  }
}

export default Cell;



// WEBPACK FOOTER //
// ./src/components/Pagination/Cell.js